import { ErrorBoundary } from 'react-error-boundary';
import { clearStorage } from '@/lib/storage';
import { trackError } from '@/lib/error-tracking';

function ErrorFallback({ error, resetErrorBoundary }: { error: Error; resetErrorBoundary: () => void }) {
  const handleReset = () => {
    clearStorage();
    resetErrorBoundary();
  };

  return (
    <div className="flex flex-col items-center justify-center min-h-screen p-4">
      <div className="max-w-md w-full space-y-4 text-center">
        <h2 className="text-2xl font-bold text-gray-900">Something went wrong</h2>
        <pre className="text-sm text-red-600 bg-red-50 p-4 rounded-md overflow-auto">
          {error.message}
        </pre>
        <button
          onClick={handleReset}
          className="w-full py-2 px-4 bg-lime text-black rounded-md hover:bg-lime/90 transition-colors"
        >
          Try again
        </button>
        <p className="text-sm text-gray-500">
          If the problem persists, please refresh the page or contact support.
        </p>
      </div>
    </div>
  );
}

export function AppErrorBoundary({ children }: { children: React.ReactNode }) {
  return (
    <ErrorBoundary
      FallbackComponent={ErrorFallback}
      onReset={() => {
        // Reset the app state here
        window.location.href = '/';
      }}
      onError={(error, info) => {
        // Track the error with our error tracking utility
        trackError(error, {
          component_stack: info.componentStack,
          react_error_boundary: true
        });
      }}
    >
      {children}
    </ErrorBoundary>
  );
} 